import { useState } from "react";
import TabNav from "../../composants/TabNav/TabNav";
import './Assistance.css';
// Import JSON
import faq from "../../Data/faq.json";
import glossary from "../../Data/glossary.json";

export default function CentralisPage() {
  const [activeTab, setActiveTab] = useState(0);
  const [openIndex, setOpenIndex] = useState(null);
  const [activeLetter, setActiveLetter] = useState("A");

  // Fonction pour normaliser les lettres (é -> e, à -> a)
  const normalizeLetter = (letter) => {
    return letter.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase();
  }

  // Normaliser et trier le glossaire par ordre alphabétique
  const sortedGlossary = glossary
    .slice()
    .sort((a, b) => {
      const termA = normalizeLetter(a.term);
      const termB = normalizeLetter(b.term);
      return termA.localeCompare(termB);
    });

  // Extraire toutes les lettres présentes dans le glossaire (normalisées)
  const lettersSet = new Set(sortedGlossary.map(g => normalizeLetter(g.term[0])));
  const letters = Array.from(lettersSet).sort();

  // Filtrer le glossaire par lettre (normalisée)
  const filteredGlossary = sortedGlossary.filter(
    g => normalizeLetter(g.term[0]) === activeLetter
  );

  const tabs = ["FAQ", "Glossaire"];

  return (
    <div className="assistance-container">
      <h1>Assistance</h1>

      <TabNav
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={(index) => setActiveTab(index)}
      />

      {/* FAQ */}
      {activeTab === 0 && (
        <div className="faq-container">
          {faq.map((section, i) => (
            <div key={i}>
              <h2 className="faq-header">{section.category}</h2>
              <div className="faq-content">
                {section.questions.map((item, j) => {
                  const index = `${i}-${j}`;
                  return (
                    <div
                      key={index}
                      className={`faq-question ${openIndex === index ? "active-question" : ""}`}
                    >
                      <button onClick={() => setOpenIndex(openIndex === index ? null : index)}>
                        <span className="faq-question-text">{item.q}</span>
                        {openIndex === index && <div className="faq-answer">{item.a}</div>}
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Glossaire */}
      {activeTab === 1 && (
        <div className="glossary-container">
          <div className="glossary-select-wrapper">
            {/* <label htmlFor="letter-select">Choisir une lettre : </label> */}
            <select
              id="letter-select"
              value={activeLetter}
              onChange={(e) => setActiveLetter(e.target.value)}
            >
              {letters.map((letter) => (
                <option key={letter} value={letter}>
                  {letter}
                </option>
              ))}
            </select>
          </div>

          <div className="glossary">
            {filteredGlossary.map((g, i) => (
              <div key={i} className="glossary-item">
                <h3 className="glossary-item-header">{g.term}</h3>
                <p className="glossary-item-content">{g.def}</p>
              </div>
            ))}
            {filteredGlossary.length === 0 && <p>Aucun terme pour cette lettre.</p>}
          </div>
        </div>
      )}
    </div>
  );
}